/* @flow */

import React, { Component } from 'react';
import glamorous from 'glamorous';
import { borderWidth, margin, padding } from 'polished';
import ConfirmButton from 'app/components/styled/ConfirmButton';
import FormValidationMessage from 'app/components/commons/FormValidationMessage';
import Loader from 'app/components/commons/Loader';
import t from 'app/utils/translate';

type Props = {
  errors: Array<*>,
  isUpdating: boolean,
  onSubmit: (Object) => void,
};

type State = {
  displayErrors: boolean,
  firstName: string,
  lastName: string,
};

const Error = glamorous.div(props => ({
  color: props.theme.color.danger,
  fontSize: '0.8rem',
}));

const Form = glamorous.form({});

const Input = glamorous.input({
  background: 'none',
  borderColor: 'currentColor',
  borderStyle: 'solid',
  ...borderWidth('0', '0', '1'),
  color: 'currentColor',
  ...margin(null, '1rem'),
  outline: 0,
  margin: 0,
  width: '100%',
  '&::placeholder': {
    color: 'currentColor',
    borderColor: 'currentColor',
    opacity: 0.5,
    fontSize: '0.8rem',
    fontWeight: 600,
  },
});

const InputFields = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  paddingBottom: '1.5rem',
});

const InputWrapper = glamorous.div({
  ...padding('0', '1rem'),
  flexGrow: 1,
  maxWidth: '14rem',
});

class NameUpdateForm extends Component {
  props: Props;
  state: State = {
    displayErrors: false,
    firstName: '',
    lastName: '',
  };

  handleFirstNameChange = ({ target }: SyntheticInputEvent) => {
    this.setState({
      firstName: target.value,
    });
  };

  handleLastNameChange = ({ target }: SyntheticInputEvent) => {
    this.setState({
      lastName: target.value,
    });
  };

  handleSubmit = (event: SyntheticEvent) => {
    const { isUpdating } = this.props;
    const { firstName, lastName } = this.state;

    event.preventDefault();

    if (isUpdating) {
      return;
    }

    if (firstName && lastName) {
      this.props.onSubmit({ firstName, lastName });
    } else {
      this.setState({
        displayErrors: true,
      });
    }
  };

  render() {
    const { errors, isUpdating } = this.props;
    const { displayErrors, firstName, lastName } = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        {errors.length > 0 && <FormValidationMessage message={errors} />}
        <InputFields>
          <InputWrapper>
            <Input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={this.handleFirstNameChange}
            />
            {displayErrors && !firstName && (
              <Error>{t('First Name field is required')}</Error>
            )}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={this.handleLastNameChange}
            />
            {displayErrors && !lastName && (
              <Error>{t('Last Name field is required')}</Error>
            )}
          </InputWrapper>
        </InputFields>
        <ConfirmButton
          type="submit"
          disabled={!firstName || !lastName}
          onSubmit={this.handleSubmit}
        >
          {isUpdating ? <Loader kind="light" /> : t('Add Name')}
        </ConfirmButton>
      </Form>
    );
  }
}

export default NameUpdateForm;
